import type { FC } from 'react';

import { useChat } from '@eneco/components/chat/useChat';
import { Button, TextLink } from '@eneco/sparky';

/** `TextLink`'s `color` prop is only assignable when `emphasis="high"` — see `TextLink.tsx`'s `EmphasisHighType`. */
export type TextLinkColor = 'linkBrand' | 'linkPrimary' | 'linkInverted';

interface ChatLinkContent {
  text?: string;
  /** Sanity's field name for what the Sitecore field calls `chattype`. */
  chatTopic?: string;
  styling?: string;
}

interface Props {
  chatLink: ChatLinkContent | undefined;
  linkColor?: TextLinkColor;
}

/**
 * CMS-agnostic port of `libs/sitecore/components/content/src/TitleTextCTA/ChatLink.tsx`. Drops the
 * Sitecore Experience Editor `wrap()` call — this lane never runs inside the Experience Editor.
 */
export const ChatLink: FC<Props> = ({ chatLink, linkColor }) => {
  try {
    const [mount] = useChat();
    const clickHandler = () => mount({ visibility: 'open', topic: chatLink?.chatTopic });

    if (!chatLink?.text) return null;

    if (chatLink.styling === 'button') {
      return <Button onClick={clickHandler}>{chatLink.text}</Button>;
    }
    return (
      <TextLink onClick={clickHandler} color={linkColor} emphasis="high">
        {chatLink.text}
      </TextLink>
    );
    // Do not render anything if useChat throws an error
  } catch {
    return null;
  }
};
